import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { useUtilityAlertIconStyle as d } from "./index.es5537.js";
const p = ({
  variant: r = "outline",
  size: l = 16,
  color: o = "default"
}) => {
  const { fillColor: n, innerElementFill: c, strokeColor: s, setIsHovered: i } = d({
    color: o,
    variant: r
  });
  return /* @__PURE__ */ t(
    "svg",
    {
      width: l,
      height: l,
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      onMouseEnter: () => i(!0),
      onMouseLeave: () => i(!1),
      children: [
        /* @__PURE__ */ t("g", { clipPath: "url(#clip0_22769_39442)", children: [
          /* @__PURE__ */ e("circle", { cx: "8", cy: "8", r: "7.5", fill: n, stroke: s }),
          /* @__PURE__ */ e(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M6.09283 5.03229C5.79994 4.7394 5.32506 4.7394 5.03217 5.03229C4.73928 5.32519 4.73928 5.80006 5.03217 6.09295L6.93922 8L5.03217 9.90705C4.73928 10.1999 4.73928 10.6748 5.03217 10.9677C5.32506 11.2606 5.79994 11.2606 6.09283 10.9677L7.99988 9.06066L9.90693 10.9677C10.1998 11.2606 10.6747 11.2606 10.9676 10.9677C11.2605 10.6748 11.2605 10.1999 10.9676 9.90705L9.06054 8L10.9676 6.09295C11.2605 5.80006 11.2605 5.32519 10.9676 5.03229C10.6747 4.7394 10.1998 4.7394 9.90693 5.03229L7.99988 6.93934L6.09283 5.03229Z",
              fill: c
            }
          )
        ] }),
        /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", { id: "clip0_22769_39442", children: /* @__PURE__ */ e("rect", { width: "16", height: "16", fill: "white" }) }) })
      ]
    }
  );
};
export {
  p as UtilityErrorIcon
};
//# sourceMappingURL=index.es432.js.map
